import { DialogComponent } from '@theme/dialog';
import { setupModalDeeplink } from '@theme/modal-deeplink';

class ContentModal extends DialogComponent {
  #trigger = null;
  #cleanupDeeplink = null;

  connectedCallback() {
    super.connectedCallback();
    this.#trigger = this.querySelector('[data-content-modal-trigger]');
    this.#trigger?.addEventListener('click', this.#handleTriggerClick);
    this.addEventListener('bottom-drawer:close', this.closeDialog);
    this.#cleanupDeeplink = setupModalDeeplink(this, {
      id: this.dataset.modalId,
      open: this.#open,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#trigger?.removeEventListener('click', this.#handleTriggerClick);
    this.removeEventListener('bottom-drawer:close', this.closeDialog);
    this.#cleanupDeeplink?.();
  }

  #open = () => {
    this.showDialog();
    requestAnimationFrame(() => {
      const closeBtn = this.querySelector('[data-close-trigger]');
      if (closeBtn instanceof HTMLElement) closeBtn.focus({ preventScroll: true });
    });
  };

  #handleTriggerClick = (event) => {
    event.preventDefault();
    this.#open();
  };
}

if (!customElements.get('content-modal')) {
  customElements.define('content-modal', ContentModal);
}
